@if (!isMobileView) {
  <table
    class="invoice-apply-table d-none d-md-block d-lg-block"
    mat-table
    [dataSource]="dataSource"
    matSort
    (matSortChange)="announceSortChange($event)"
    >
    <ng-container matColumnDef="billTo">
      <th class="heading" mat-header-cell mat-sort-header *matHeaderCellDef disableClear="true">
        {{"iframesection.billaddrlabel" | cxTranslate}}<br>{{"iframesection.billaddrlabel1" | cxTranslate}}
      </th>
      <td mat-cell class="matRow" *matCellDef="let element">
        {{ element.billTo.billingAddress }}
      </td>
    </ng-container>
    <ng-container matColumnDef="invoiceDate">
      <th
        class="invoiceDate"
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        disableClear="true"
        sortActionDescription="Sort by Date"
        >
        {{"iframesection.dateissuedlabel" | cxTranslate}}
      </th>
      <td mat-cell class="matRow" *matCellDef="let element">
        {{ element.invoiceDate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="invoiceNumber">
      <th class="invoiceNumber" mat-header-cell mat-sort-header *matHeaderCellDef disableClear="true">
        {{"iframesection.creditnotelabel" | cxTranslate}}
      </th>
      <td mat-cell class="matRow" *matCellDef="let element">
        {{ element.invoiceNumber }}
      </td>
    </ng-container>
    <ng-container matColumnDef="formattedAmountWithTax">
      <th
        class="formattedAmountWithTax"
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        disableClear="true"
        >
        {{"iframesection.creditamntlabel" | cxTranslate}}
      </th>
      <td mat-cell class="matRow" *matCellDef="let element">
        {{ element.formattedAmountWithTax }}
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th class="status" mat-header-cell *matHeaderCellDef></th>
      <!-- <td mat-cell class="invoice_applybutton" *matCellDef="let element">{{element.formattedAmountWithTax}} </td> -->
      <td
        mat-cell
        class="matRow invoice_applybutton"
        *matCellDef="let element; let i = index"
        >
        <span
          id="appliedId-{{ i }}"
          class="buttonStyles applyCreditClass"
        (click)="
          creditApplied(
            $event,
            element.amoutWithTax,
            'credit',
            element.invoiceNumber,
            i
          )
        "
          >{{"iframesection.applylabel" | cxTranslate}} <i class="glyphicon glyphicon-plus invoiceCreditIcon"></i
        ></span>
        <span
          id="removeId-{{ i }}"
          class="buttonStyles removeCreditClass"
        (click)="
          creditApplied(
            $event,
            element.amoutWithTax,
            'remove',
            element.invoiceNumber,
            i
          )
        "
          >{{"iframesection.removelabel" | cxTranslate}} <i class="glyphicon glyphicon-minus invoiceCreditIcon"></i
        ></span>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="creditcolumns"></tr>
    <tr mat-row *matRowDef="let row; columns: creditcolumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-matching-invoices" colspan="4">{{"allinvoice.norecordstxt" | cxTranslate}}</td>
    </tr>
  </table>
}

@if (isMobileView) {
  <table
    class="invoice-apply-table mobile d-block d-lg-none"
    mat-table
    [dataSource]="dataSource"
    matSort
    (matSortChange)="announceSortChange($event)"
    >
    <ng-container matColumnDef="combined">
      <th class="odertableheader" mat-header-cell *matHeaderCellDef>
        order Data
      </th>
      <td mat-cell *matCellDef="let element;let i=index" class="combined_mobile_table">
        <div class="applycredit-mob">
          <div class="applycredit-mobaddr">{{ element.billTo.billingAddress }}</div>
          <div class="applycredit-mobdate"><span>{{"iframesection.dateissuedlabel" | cxTranslate}} :</span><span class="credit_datemob">{{ element.invoiceDate }}</span></div>
          <div class="applycredit-mobcreditno"><span>{{"iframesection.creditnotelabel" | cxTranslate}} :</span><span>{{ element.invoiceNumber }}</span></div>
          <div class="applycredit-mobcreditamnt"><span>{{"iframesection.creditamntlabel" | cxTranslate}} :</span><span>{{ element.formattedAmountWithTax }}</span></div>
          <div class="applycredit-button">
            <span
              id="appliedId-{{ i }}"
              class="buttonStyles applyCreditClass"
        (click)="
          creditApplied(
            $event,
            element.amoutWithTax,
            'credit',
            element.invoiceNumber,
            i
          )
        "
              >{{"iframesection.applylabel" | cxTranslate}} <i class="glyphicon glyphicon-plus invoiceCreditIcon"></i
            ></span>
            <span
              id="removeId-{{ i }}"
              class="buttonStyles removeCreditClass"
        (click)="
          creditApplied(
            $event,
            element.amoutWithTax,
            'remove',
            element.invoiceNumber,
            i
          )
        "
              >{{"iframesection.removelabel" | cxTranslate}} <i class="glyphicon glyphicon-minus invoiceCreditIcon"></i
            ></span>
          </div>
        </div>
      </td>
    </ng-container>
    <tr mat-row *matRowDef="let row; columns: creditColumnmobile"  class="table-row"></tr>
    <tr mat-header-row *matHeaderRowDef="creditColumnmobile" class="header-row"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-matching-invoices" colspan="4">{{"allinvoice.norecordstxt" | cxTranslate}}</td>
    </tr>
  </table>
}
